import { types } from 'mobx-state-tree'
import * as StringTools from '~/utilities/string'

const TrafficState = types.model('TrafficState', {
  id: types.optional(types.identifier, StringTools.random),
  longName: types.string,
  shortName: types.string,
  available: types.boolean,
  prospect: types.boolean,
  affiliatedWithWinitLaw: types.optional(types.boolean, false),
  isPQFlowEnabled: types.optional(types.boolean, false),
})

export default TrafficState
